//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Row } from "antd";
import React, { useMemo } from "react";
import styled from "styled-components";
//  -- Constants ----------------------
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import COLOR from "utils/constants/color";
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const Image = styled.img`
  width: 100%;
  min-height: 220px;
`;

const ModalRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 16px;
  width: 100%;
`;

const Text = styled.span`
  color: ${COLOR.black500};
  font-size: 11px;
  margin-top: 2px;
  text-align: left;
`;

const TextContainer = styled.div`
  border-top: 1px solid ${COLOR.black800};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  padding: 0px 16px;
  background-color: #171e2d;
`;

const ModalContent = styled.div`
  align-items: center;
  background-color: ${COLOR.white};
  border-radius: 3px;
  display: inline-flex;
  flex-direction: column;
  left: 50%;
  max-width: 320px;
  padding: 16px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
`;
const TopRow = styled(Row)`
  border: 0.5px solid #3c393957;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  justify-content: space-between;
`;

const Wrapper = styled.button`
  background-color: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: auto;
  outline: none;
  padding: 2px;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  position: relative;
  overflow: hidden;

  /* Box shadow based on selection state */
  box-shadow: ${({ selected }) =>
    selected
      ? "0 0 12px 4px rgba(24, 144, 255, 0.8)" // brighter highlight for selected
      : "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)"};

  /* Background subtle effect on selection */
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ selected }) =>
      selected ? "rgba(24, 144, 255, 0.05)" : "transparent"};
    z-index: 0;
    transition: background-color 300ms ease;
  }

  /* Border effect on selection */
  border: ${({ selected }) =>
    selected ? "2px solid rgba(24, 144, 255, 0.7)" : "2px solid transparent"};

  /* Scale effect when clicked */
  &:active {
    transform: scale(0.98);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  }

  /* Hover effects */
  &:hover {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.18), 0 4px 8px rgba(0, 0, 0, 0.16);

    &:before {
      background-color: rgba(0, 0, 0, 0.03);
    }
  }

  /* Ripple effect on click */
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 5px;
    height: 5px;
    background: rgba(255, 255, 255, 0.5);
    opacity: 0;
    border-radius: 100%;
    transform: scale(1, 1) translate(-50%, -50%);
    transform-origin: 50% 50%;
  }

  &:focus:not(:active)::after {
    animation: ripple 0.6s ease-out;
  }

  @keyframes ripple {
    0% {
      transform: scale(0, 0) translate(-50%, -50%);
      opacity: 0.5;
    }
    100% {
      transform: scale(20, 20) translate(-50%, -50%);
      opacity: 0;
    }
  }

  /* Ensure content is above pseudo-elements */
  & > * {
    position: relative;
    z-index: 1;
  }
`;

const BalconCover = ({
  data,
  handleClick,
  onDelete,
  setDeleteToggle,
  selection,
  selectedItem,
}) => {
  const selectedDataIds = useMemo(() => {
    return selectedItem?.map((item) => item.id) || "";
  }, [selectedItem]);

  return (
    <>
      <TopRow>
        <Text style={{ fontWeight: "bold", color: "black" }}>
          <strong> Id: {data.id}</strong>
        </Text>
        {selection ? null : (
          <IconButton
            onClick={() => {
              if (data.src) {
                setDeleteToggle(data.id);
              } else {
                onDelete(data.id);
              }
            }}
            style={{ padding: 0 }}
          >
            <Delete color="secondary" />
          </IconButton>
        )}
      </TopRow>
      <Wrapper selected={selectedDataIds?.includes(data?.id)}>
        <div onClick={() => handleClick(data)} className="card-resource">
          <a>
            <div className="card-resource-overlay"></div>
            <Image
              className="card-resource-image"
              src={data.src}
              alt={data.shortName}
            />
            <div className="card-resource-details fadeIn-bottom">
              <h3 className="card-resource-title">{data.shortName}</h3>
            </div>
          </a>
        </div>
      </Wrapper>
    </>
  );
};


export default BalconCover;
